import React from "react";
import { createRoot } from "react-dom/client";
import { flushSync } from "react-dom";
import "./index.css";
import App from "./App";

// Rendu synchrone : les liens tel: sont dans le DOM avant l'exécution du script
// de suivi d'appels (public/js/suivi-appels.js), qui s'appuie sur DOMContentLoaded.
const root = createRoot(document.getElementById("root"));
flushSync(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
